import { render } from "./ChatBotPurchasePropsCmp.vue?vue&type=template&id=538d519b"
import script from "./ChatBotPurchasePropsCmp.vue?vue&type=script&lang=js"
export * from "./ChatBotPurchasePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__